function PageNotFound() {
  return (
    <div className="h-full flex flex-col justify-center items-center ">
      <h1 className="text-5xl font-bold text-custom-blue">404</h1>
      <p className="text-2xl">Page not found.</p>
    </div>
  );
}

export default PageNotFound;
